import { Fragment, useState } from "react";
import { moveModal, getDateString } from "../../utils/Utils";
import "../../css/modal/LessonBannedModal.css"
import proxy from "../../utils/Proxy";
import Days from "../../utils/constants/Days";

let LessonBannedModal = (props) => {
    let [banned, setBanned] = useState({ ...props.data.banned })

    let date = new Date(props.data.date)
    let shortDateString = getDateString(date, true)
    let day = Days.korean[date.getDay()]

    let onClickCell = (teacherid, time) => {
        if (props.data.alreadyReservation[teacherid][time]) {
            window.alert("선택한 시간대에 레슨이 예약되어 있습니다.")
            return;
        }
        setBanned(prevState => {
            return ({ ...prevState, [teacherid]: { ...prevState[teacherid], [time]: !prevState[teacherid][time] } })
        })
    }

    let onClickName = (teacherid, enableTimes) => {
        setBanned(prevState => {
            let change = false
            for (let time of Days.timeset) {
                let notAllSelected = !prevState[teacherid][time] && enableTimes.includes(time) && !props.data.alreadyReservation[teacherid][time]
                if (notAllSelected) {
                    change = true
                    break
                }
            }
            let nextState = {}
            for (let time of Days.timeset) {
                let changeable = enableTimes.includes(time) && !props.data.alreadyReservation[teacherid][time]

                if (changeable) nextState[time] = change
                else nextState[time] = false
            }
            return ({ ...prevState, [teacherid]: nextState })
        })
    }

    let onSubmitClick = async () => {
        for (let teacherData of props.data.teachersData) {
            let teacherid = teacherData.teacherid

            let edit = []

            for (let time of Days.timeset) {
                if (banned[teacherid][time] !== props.data.banned[teacherid][time]) {
                    edit.push([time, banned[teacherid][time]])
                }
            }
            for (let [time, isAdd] of edit) {
                if (isAdd) {
                    let body = {
                        date: getDateString(date),
                        hour: time,
                        teacherid: teacherid
                    }
                    let result = await proxy.post("/adminapi/lessons/banned", body).catch(() => {
                        window.alert("선택한 시간대에 레슨이 예약되어 있습니다.")
                        props.onCloseClick()
                        props.onSuccess()
                    })
                    if (!result) {
                        return
                    }
                }
                else {
                    let bannedid = props.data.bannedidMap.get(teacherid + ":" + time)
                    await proxy.delete("/adminapi/lessons/banned/" + bannedid)
                }
            }
        }

        window.alert("저장 하였습니다.")
        props.onCloseClick()
        props.onSuccess()
    }

    let onCloseClick = () => {
        let dialogResult = window.confirm("취소 하시겠습니까?")
        if (dialogResult) {
            props.onCloseClick()
        }
    }

    return (
        <div className="modal-container">
            <div className="modal" id="lesson-banned-modal">
                <div className="modal-content-container">
                    <div className="modal-header" onMouseDown={(e) => moveModal(e, "lesson-banned-modal")}>
                        <p className="modal-title">
                            레슨 가능 시간 설정
                        </p>
                        <div className="modal-close-button" onClick={onCloseClick}></div>
                    </div>
                    <div className="modal-content">

                        <div className="banned-table-date-wrapper">
                            <p className="banned-table-date">
                                {shortDateString + "(" + day + ")"}
                            </p>
                        </div>
                        <div className="banned-table-container">
                            <div className="banned-table-sidebar">
                                <div key={"empty-start-cell"} />
                                {Days.timeset.map((time) => {
                                    return (
                                        <div key={time}><p>{time + ":00"}</p></div>
                                    )
                                })}
                            </div>
                            <div className="banned-table-content">
                                {props.data.teachersData.map(teacherData => {
                                    return (
                                        <Fragment key={teacherData.teacherid}>
                                            <div className="banned-table-teacher-cell"
                                                onClick={() => onClickName(teacherData.teacherid, teacherData.enableTimes)} >
                                                <p> {teacherData.name}</p>
                                            </div>
                                            {Days.timeset.map(time => {
                                                let enable = teacherData.enableTimes.includes(time)
                                                if (enable) {
                                                    return (
                                                        <div className={"banned-table-cell" + (banned[teacherData.teacherid][time] ? "-banned" : "")}
                                                            key={teacherData.teacherid + ":" + time}
                                                            onClick={() => onClickCell(teacherData.teacherid, time)} />)
                                                } else {
                                                    return (
                                                        <div className="banned-table-cell-disable"
                                                            key={teacherData.teacherid + ":" + time} />)
                                                }
                                            })}
                                        </Fragment>

                                    )
                                })}
                            </div>
                        </div>

                    </div>
                    <div className="modal-footer">
                        <div className="modal-footer-button-container">
                            <div className="modal-button" onClick={onSubmitClick}>
                                <p>저장</p>
                            </div>
                            <div className="modal-button" onClick={onCloseClick} >
                                <p>취소</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default LessonBannedModal;